import { useQuery } from '@tanstack/react-query'
import { api } from '../services/api/client'

export interface DashboardStats {
  todayVisits: number
  todayCompleted: number
  upcomingVisits: number
  totalPatients: number
  totalDocuments: number
  weeklyActivity: Array<{ date: string; count: number }>
  monthlyActivity: Array<{ month: string; count: number }>
}

interface ApiResponse {
  success: boolean
  data: DashboardStats
}

export function useDashboardStats() {
  return useQuery<DashboardStats>({
    queryKey: ['dashboard', 'stats'],
    queryFn: async () => {
      const res = await api.get<ApiResponse>('/dashboard/stats')
      return res.data.data
    },
    staleTime: 60_000,
    refetchInterval: 120_000,
  })
}
